"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarType = void 0;
/* eslint-disable camelcase */
var AvatarType;
(function (AvatarType) {
    AvatarType[AvatarType["Tournament"] = 0] = "Tournament";
    AvatarType[AvatarType["User"] = 1] = "User";
    AvatarType[AvatarType["CustomCourse"] = 2] = "CustomCourse";
    AvatarType[AvatarType["Default"] = 3] = "Default";
})(AvatarType = exports.AvatarType || (exports.AvatarType = {}));
